import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const actions = {

    async createRequest(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/requests/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async createRequestIncrease(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/requests/${payload.id_request}/increases/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateRequest(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/requests/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async fetchRequest(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/requests/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchRequestIncreases(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/requests/${query.id}/increases/${query.ctx}`)
            .then((response) => {
                return response.data;
            })
    },

    async getRequestById(context, id) {
        return axios
            .get(`${serverUrl}/api/v1/requests/${id}`)
            .then((response) => {
                return response.data;
            })
    },

    async rejectRequest(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/requests/${payload.id}/reject/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async rejectRequestIncrease(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/requests/${payload.request}/increases/${payload.id}/reject/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async approveRequest(context, file) {
        return axios
            .post(`${serverUrl}/api/v1/requests/${file.get('id')}/approve/`, file)
            .then((response) => {
                return response.data;
            })
    },

    async approveRequestIncrease(context, file) {
        return axios
            .post(`${serverUrl}/api/v1/requests/${file.get('request')}/increases/${file.get('id')}/approve/`, file)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsRequestState(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/requests/states/${query}`)
            .then((response) => {
                return response.data;
            })
    },

}